import type { ReactNode } from 'react';
import { useFela } from 'react-fela';
import { Link } from 'react-router-dom';

import { config } from '@/config/config';
import { Heading, Icon, Text } from '@/modules/ui';

import * as felaRules from './SettingsDetailLayout.rules';

export interface SettingsDetailLayoutProps {
    title: string;
    description?: string;
    divider?: boolean;
    /** Right-aligned in the title row, opposite the title. */
    action?: ReactNode;
    backTo?: string;
    children: ReactNode;
}

export const SettingsDetailLayout = ({
    title,
    description,
    divider = true,
    action,
    backTo = config.routes.settings,
    children,
}: SettingsDetailLayoutProps) => {
    const { css } = useFela({ divider });

    return (
        <div className={css(felaRules.container)}>
            <div className={css(felaRules.titleContainer)}>
                <div className={css(felaRules.titleRow)}>
                    <Heading elementType='h1' color='black' customStyle={felaRules.title}>
                        <Link to={backTo} className={css(felaRules.link)}>
                            <Icon type='dropdown' />
                        </Link>
                        {title}
                    </Heading>
                    {action}
                </div>
                {description && (
                    <Text variant='ParagraphSmallMedium' color='brownGrey2' customStyle={felaRules.description}>
                        {description}
                    </Text>
                )}
            </div>
            {children}
        </div>
    );
};
